<template>
    <div>
        <panel :title="$t('str.table.list.sites')" bodyClass="p-0">
            <div class="row ms-2 mb-1 mt-3 me-1">
                <div v-if="isSuperAdminMaster" class="col-md-3 mb-3">
                    <label class="form-label" for="accountField">{{ $t('str.register.site.account.field') }}</label>
                    <select v-model="filters.account" @change="changeAccount" class="form-select" id="accountField">
                        <option value="">{{ $t('str.register.select.placeholder') }}</option>
                        <option v-for="account in accounts" :value="account._id" :key="account._id">
                            {{ account?.name }}
                        </option>
                    </select>
                </div>
                <div v-if="role === 'SUPER_ADMIN_MASTER' || role === 'ADMIN' || role === 'MANAGER'" class="col-md-3 mb-3">
                    <label class="form-label" for="clientField">{{ $t('str.register.site.client.field') }}</label>
                    <select v-model="filters.client" @change="filterFromFirstPage" class="form-select" id="clientField">
                        <option value="">{{ $t('str.register.select.placeholder') }}</option>
                        <option v-for="client in clients" :value="client._id" :key="client._id">
                            {{ client.name }}
                        </option>
                    </select>
                </div>
                <div class="col-md-3">
                    <label class="form-label" for="statusField">{{ $t('str.register.status.field') }}</label>
                    <select v-model="filters.status" @change="filterFromFirstPage" class="form-select" id="statusField">
                        <option value="ACTIVE">{{ $t('str.register.status.active') }}</option>
                        <option value="ARCHIVED">{{ $t('str.register.status.archived') }}</option>
                    </select>
                </div>
                <div class="col-md-3 mt-4">
                    <button v-if="role !== 'AUDITOR'" @click="selectItem" type="submit" class="btn btn-default w-50">{{ $t('str.btn.new.form') }}</button>
                </div>
            </div>
            <vue-good-table
                :columns="columns"
                :rows="items"
                :lineNumbers="true"
                @on-row-click="selectItem"
                :search-options="{ enabled: true, placeholder: $t('str.table.search.in.this.table') }"
                :pagination-options="paginationOptions"
                :totalRows="totalItems"
                @on-page-change="onPageChange"
                @on-per-page-change="onPerPageChange"
                tableLayout="fixed"
            >
                <div slot="emptystate" class="vgt-center-align vgt-text-disabled">
                    <i v-if="isLoading" class="fas fa-spinner fa-spin" />
                    <span v-if="!isLoading && items?.length === 0">{{ $t('str.table.subtitle.no.data') }}</span>
                </div>
                <template slot="table-row" slot-scope="props">
                    <span v-if="props.column.field === 'address'">
                        {{
                            props.formattedRow[props.column.field]
                                ? props.formattedRow[props.column.field].address +
                                  ' ' +
                                  props.formattedRow[props.column.field].number +
                                  ', ' +
                                  props.formattedRow[props.column.field].neighborhood +
                                  ', ' +
                                  props.formattedRow[props.column.field].city +
                                  '- ' +
                                  props.formattedRow[props.column.field].state
                                : ''
                        }}
                    </span>
                    <span v-else-if="props.column.field === 'account'">
                        {{ props.formattedRow[props.column.field].name }}
                    </span>
                    <span v-else-if="props.column.field === 'client'">
                        {{ props.formattedRow[props.column.field].name }}
                    </span>
                    <span v-else-if="props.column.field === 'enableFreePatrol'">
                        <span class="badge" v-bind:class="props.formattedRow[props.column.field] === true ? 'bg-success' : 'bg-warning'">
                            {{ $t(props.formattedRow[props.column.field] ? 'str.yes' : 'str.no') }}
                        </span>
                    </span>
                    <span v-else-if="props.column.field === 'createDate'">
                        {{ formatDate(props.formattedRow[props.column.field]) }}
                    </span>
                    <span v-else-if="props.column.field === 'status'">
                        <span class="badge" v-bind:class="props.formattedRow[props.column.field] === 'ACTIVE' ? 'bg-success' : 'bg-danger'"> {{ $t(props.formattedRow[props.column.field]) }} </span>
                    </span>
                    <span v-else>
                        {{ props.formattedRow[props.column.field] }}
                    </span>
                </template>
            </vue-good-table>
        </panel>
        <SiteModal :selectedData="data" />
        <notifications group="bottom-right" position="bottom right" :speed="500" />
    </div>
</template>

<script>
import Vue from 'vue'

import { site } from '../../../types/site'
import Controller from './CrtListSite.vue'
import SiteModal from './Site.vue'
import serverPaginationMixin from '../../../utils/serverPaginationMixin'

Vue.prototype.$registerEvent = new Vue()

export default {
    mixins: [serverPaginationMixin],
    components: {
        SiteModal,
    },
    data() {
        return {
            items: [],
            isLoading: false,
            data: {},
            filters: {
                account: '',
                client: '',
                type: 'SITE',
                status: 'ACTIVE',
                statusActive: false,
                name: '',
            },
            siteObj: JSON.parse(JSON.stringify(site)),
            accounts: [],
            clients: [],
            sites: [],
            columns: [],
            role: '',
            paginationOptions: {},
            isSuperAdminMaster: false,
        }
    },
    mounted() {
        Controller.init(this)
    },
    created() {
        let state = this
        this.$registerEvent.$on('refreshList', function () {
            state.filter()
        })
        this.$registerEvent.$on('changeLanguage', function () {
            state.initTable()
        })
    },
    methods: Controller.methods,
}
</script>
